import { Module } from 'vuex'
import { RootState, SupportPreferencesState } from './state_models'

export const supportPreferences: Module<SupportPreferencesState, RootState> = {
  namespaced: true,
  state: {
    showLockout: true,
  },
  getters: {
    isLockoutSkipped(state): boolean {
      return !state.showLockout
    },
  },
  mutations: {
    setShowLockout(state, value: boolean) {
      state.showLockout = value
    },
  },
  actions: {
    setSupportPreferences({ commit }, data: SupportPreferencesState) {
      commit('setShowLockout', data.showLockout)
    },
  },
}
